import { handleActions } from 'redux-actions';
import { OperatorsState } from './interfaces';
import Types from './types';

const initialState: OperatorsState = {
  isLoading: false,
  checks: [],
  operatorDetails: null,
  operatorTokens: {
    count: 0,
    next: '',
    previous: '',
    loading: false,
    results: [],
  },
  operatorList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  operatorRoles: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  isLoadingOperatorRoles: false,
};

export default handleActions(
  {
    [Types.NEW_OPERATOR_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_OPERATOR_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_OPERATOR_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.NEW_OPERATOR_AT_GROUP_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_OPERATOR_AT_GROUP_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_OPERATOR_AT_GROUP_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.UPDATE_PERMISSIONS_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.UPDATE_PERMISSIONS_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.UPDATE_PERMISSIONS_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_OPERATOR_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_OPERATOR_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_OPERATOR_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_OPERATOR_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_OPERATOR_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_OPERATOR_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_OPERATOR_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
      operatorDetails: null,
    }),
    [Types.GET_OPERATOR_FULFILLED]: (state: OperatorsState, { payload }) => ({
      ...state,
      isLoading: false,
      operatorDetails: payload,
    }),
    [Types.GET_OPERATOR_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_OPERATOR_TOKENS_REQUEST]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: true,
      },
    }),
    [Types.GET_OPERATOR_TOKENS_FULFILLED]: (
      state: OperatorsState,
      { payload }
    ) => ({
      ...state,
      operatorTokens: {
        ...payload,
        loading: false,
      },
    }),
    [Types.GET_OPERATOR_TOKENS_REJECTED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),

    [Types.NEW_OPERATOR_TOKEN_REQUEST]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: true,
      },
    }),
    [Types.NEW_OPERATOR_TOKEN_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),
    [Types.NEW_OPERATOR_TOKEN_REJECTED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),

    [Types.REMOVE_OPERATOR_TOKEN_REQUEST]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: true,
      },
    }),
    [Types.REMOVE_OPERATOR_TOKEN_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),
    [Types.REMOVE_OPERATOR_TOKEN_REJECTED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),

    [Types.EDIT_OPERATOR_TOKEN_REQUEST]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: true,
      },
    }),
    [Types.EDIT_OPERATOR_TOKEN_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),
    [Types.EDIT_OPERATOR_TOKEN_REJECTED]: (state: OperatorsState) => ({
      ...state,
      operatorTokens: {
        ...state.operatorTokens,
        loading: false,
      },
    }),

    [Types.GET_ALL_OPERATORS_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_OPERATORS_FULFILLED]: (
      state: OperatorsState,
      { payload }
    ) => ({
      ...state,
      operatorList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_OPERATORS_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.TOGGLE_BLOCK_OPERATOR_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.TOGGLE_BLOCK_OPERATOR_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.TOGGLE_BLOCK_OPERATOR_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.UPDATE_MFA_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.UPDATE_MFA_FULFILLED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.UPDATE_MFA_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.SET_PENDING_PERMISSIONS_REQUEST]: (
      state: OperatorsState,
      { payload }
    ) => ({
      ...state,
      checks: payload,
    }),

    [Types.GET_OPERATOR_ROLES_REQUEST]: (state: OperatorsState) => ({
      ...state,
      isLoadingOperatorRoles: true,
    }),
    [Types.GET_OPERATOR_ROLES_FULFILLED]: (
      state: OperatorsState,
      { payload }
    ) => ({
      ...state,
      isLoadingOperatorRoles: false,
      operatorRoles: payload,
    }),
    [Types.GET_OPERATOR_ROLES_REJECTED]: (state: OperatorsState) => ({
      ...state,
      isLoadingOperatorRoles: false,
    }),
  },
  initialState
);
